"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateDonorFeesStripe = void 0;
const enums_1 = require("../types/enums");
const utils_1 = require("../utils");
const constants_1 = require("../constants");
const calculateStripeFees_1 = require("./calculateStripeFees");
const calculateDonorFeesStripe = ({ amount = 0, coverFees = false, nonprofitCountryCode = 'US', feeCoveredBy = enums_1.FeeCoveredBy.User, isSandbox, applicationFeeSetting = constants_1.DEFAULT_APPLICATION_FEE_EMPLOYEE, applicationFeeAmountCap, cardCountryCode = 'US', }) => {
    if (!nonprofitCountryCode) {
        throw new Error('nonprofitCountryCode is required when donating with Stripe');
    }
    if (!cardCountryCode) {
        throw new Error('cardCountryCode is required when donating with Stripe');
    }
    const { providerFeeAmountCents, applicationFeeAmountCents, totalFeeAmountCents } = (0, calculateStripeFees_1.calculateStripeFee)({
        amountCents: amount * utils_1.CENTS_AMOUNT,
        accountCountryCode: nonprofitCountryCode,
        cardCountryCode,
        applicationFee: feeCoveredBy === enums_1.FeeCoveredBy.Deed ? 0 : applicationFeeSetting,
        applicationFeeAmountCentsCap: applicationFeeAmountCap * utils_1.CENTS_AMOUNT,
        coverFees,
        isSandbox,
    });
    return {
        providerFeeAmount: providerFeeAmountCents / utils_1.CENTS_AMOUNT,
        applicationFeeAmount: applicationFeeAmountCents / utils_1.CENTS_AMOUNT,
        totalFeeAmount: totalFeeAmountCents / utils_1.CENTS_AMOUNT,
    };
};
exports.calculateDonorFeesStripe = calculateDonorFeesStripe;
//# sourceMappingURL=calculateDonorFeesStripe.js.map